export const listaInvitados = {
  "familia-jaziel-celina": {
    nombre: "Jaziel y Celina",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "",
    telefono: ""
  }
};
